import { render, staticRenderFns } from "./CredenciamentoVisualizacaoAcoes.vue?vue&type=template&id=4aceb830&scoped=true&"
import script from "./CredenciamentoVisualizacaoAcoes.vue?vue&type=script&lang=js&"
export * from "./CredenciamentoVisualizacaoAcoes.vue?vue&type=script&lang=js&"
import style0 from "./CredenciamentoVisualizacaoAcoes.vue?vue&type=style&index=0&id=4aceb830&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aceb830",
  null
  
)

export default component.exports